import request from './request'

export function login(data) {
  return request({
    url: '/admin/auth/login',
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: '/admin/auth/logout',
    method: 'post'
  })
}

export function getProfile() {
  return request({
    url: '/admin/user/profile',
    method: 'get'
  })
}

export function getPermissionResources() {
  return request({
    url: '/admin/permission/resources',
    method: 'get'
  })
}
